import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    wrapper: {
        justifyContent: "flex-start",
        display: "flex",
        marginTop: "0.5rem",
        marginLeft: ({ isNavbarOpen }) => (isNavbarOpen ? "21%" : "12%"),
        padding: "5px",
    },
    viewContainer: {
        width: "100%",
    },
    title: {
        fontSize: "20px",
        fontWeight: "bold",
        color: ({ theme }) => theme.palette.text.primary,
        marginLeft: "0.5rem",
    },
    titleWrapper: {
        width: "99%",
        marginBottom: "13px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    pageWrapper: {
        backgroundColor: ({ theme }) => theme.palette.bgColor,
        boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        paddingInline: "10px 5px",
        fontFamily: "Rubik",
        paddingBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
        marginRight: "10px",
        marginLeft: "10px",
        flexDirection: "column",
        marginBottom: "20px",
    },
    actionWrapper: {
        display: "flex",
        gap: "10px",
        alignItems: "center",
    },
    addSupplierBtn: {
        width: "100px",
        height: "37px",
        background: "#9A0143",
        fontFamily: "Rubik",
        fontSize: "12px",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#9A0143",
        },
    },
    text: {
        color: ({ theme }) => theme.palette.text.primary,
        fontSize: "16px",
        textAlign: 'justify',
        fontWeight: '600',
        padding: '10px',
    },
    sectionsWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "100px",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: "10px"
    },
    headers: {
        textAlign: 'justify',
        fontWeight: '600',
        paddingLeft: '10px',
    },
    details: {
        fontSize: "14px",
        fontFamily: "inherit",
        fontWeight: 400,
        color: ({ theme }) => theme.palette.text.primary,
        lineHeight: "200%",
    },
    tableWrapper: {
        display: "flex",
        flexDirection: "row",
        gap: "30px",
        width: "100%",
        backgroundColor: "#b3b3b390",
        borderRadius: "10px",
    },
    actionsContainer: {
        display: "flex",
        gap: "10px",
        height: '100%',
        alignItems: 'center',
        width: '60%'
    },
    actionBtn: {
        backgroundColor: ({ theme }) => theme.palette.button.primary,
        color: ({ theme }) => theme.palette.text.primary,
        border: "2px solid #A8ABC2",
        fontWeight: 700,
        "&:hover": {
            backgroundColor: "transparent",
        },
        minWidth: "35px !important",
        height: "2.1rem",
        width: "2.1rem",
    },
    loadingContainer: {
        marginTop: "10%",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "70vh"
    },
});
